// extracted by mini-css-extract-plugin
export default {"avatar_col":"Avatar_avatar_col__bgcqc","avatar":"Avatar_avatar__hR-NV","avatar__placeholder":"Avatar_avatar__placeholder__Kxez9"};